import React from "react";
import FlipCounterOne from "./flipCounterOne";
import "./flipCounter.scss";

const FlipCounter = () => {
  return (
    <div className="flex">
      <FlipCounterOne />
      <div className="nums nums-one">
        <div className="num" data-num="0" data-num-next="0"></div>
        <div className="num" data-num="0" data-num-next="0"></div>
      </div>
      <div className="nums nums-one">
        <div className="num" data-num="0" data-num-next="0"></div>
        <div className="num" data-num="0" data-num-next="0"></div>
      </div>
    </div>
  );
};
export default FlipCounter;
